<template>
  <base-popup
    v-if="show_popup"
    v-show="popup_visibility"
    @close="close_popup"
  >
    <h4>{{ $t('common.install_app_title') }}</h4>

    <div v-if="is_ios">
      <ol>
        <li v-html="$t('common.install_app_ios_step_1')"></li>
        <li v-html="$t('common.install_app_ios_step_2')"></li>
        <li v-html="$t('common.install_app_ios_step_3')"></li>
      </ol>
    </div>

    <ol v-else>
      <li v-html="$t('common.install_app_android_step_1')"></li>
      <li v-html="$t('common.install_app_android_step_2')"></li>
    </ol>
  </base-popup>
</template>

<script>
import BasePopup from './BasePopup.vue'
const SEEN_KEY = 'wavetraders:installPromptSeen'

export default {
  components: {
    BasePopup
  },
  data () {
    return {
      show_popup: false,
      popup_visibility: false,
      is_ios: false
    }
  },
  created () {
    const is_standalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true

    if (is_standalone) {
      return
    }

    const ua = window.navigator.userAgent || ''
    this.is_ios = /iPad|iPhone|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
    const is_android = /Android/.test(ua)

    if (!this.is_ios && !is_android) {
      return
    }

    this.show_popup = true

    let already_seen = false
    try {
      already_seen = localStorage.getItem(SEEN_KEY) === '1'
    } catch (e) {}

    if (!already_seen) {
      this.auto_open_timeout = setTimeout(this.open_popup, 15000)
    }
  },
  beforeDestroy () {
    clearTimeout(this.auto_open_timeout)
  },
  methods: {
    open_popup () {
      this.popup_visibility = true

      try {
        localStorage.setItem(SEEN_KEY, '1')
      } catch (e) {}
    },
    close_popup () {
      this.popup_visibility = false
    }
  }
}
</script>

<style scoped lang="scss">
h4 {
  font-size: 16px;
  font-weight: 400;
  color: var(--dark-grey-white);
  margin-bottom: 14px;
  margin-left: -5px;
}

::v-deep ol {
  font-family: 'Athelas', arial, sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 1.63;
  letter-spacing: 0.1px;
  color: var(--charcoal-grey-white);
  padding-left: 20px;
  margin-bottom: 0;

  li:not(:last-child) {
    margin-bottom: 8px;
  }
}

::v-deep .popup-wrapper {
  height: 100%;

  .popup-content {
    text-align: left;
    padding: 30px;
    max-width: 500px;
    margin: 0 auto;
    top: 50%;
    transform: translateY(-50%);
    background-color: var(--pale-grey-two-charcoal-grey-two);
    border: 1px solid var(--pale-grey-battleship-grey-three);
  }
}

@media (max-width: 575.98px) {
  ::v-deep .base-popup {
    padding: 0 15px;

    .popup-content {
      padding: 20px;
    }
  }
}
</style>
